import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import './style.scoped.css';
import iconErrorLarge from 'src/assets/large_red_close.svg';
import iconClose from 'src/assets/close.svg';
import Button, { ButtonTypes } from 'src/components/Button';
import { handlePhoneCall } from 'src/utils/checkMobileWebView';
import { formatTextWithPhoneNumbers } from 'src/utils/phoneNumberFormatter';

export interface PopupConfirmProps {
  visible: boolean;
  children?: React.ReactNode;
  title?: string;
  content?: string;
  onOk?: () => void;
  okTitle?: string;
  okButtonComponent?: React.ReactNode;
  onCancel?: () => void;
  cancelTitle?: string;
  redConfirm?: boolean;
  type?: '';
  showContactButton?: boolean;
  showIcon?: boolean;
  okButtonType?: ButtonTypes;
  isHtmlContent?: boolean;
  popupStyle?: React.CSSProperties;
  buttonContainerStyle?: React.CSSProperties;
  hotline?: string;
  icon?: string;
  showIconClose?: boolean;
  isWebsite?: boolean;
  classIcon?: any;
}

const PopupConfirm = (props: PopupConfirmProps) => {
  const { t } = useTranslation();
  const {
    visible,
    children,
    onOk,
    onCancel,
    title,
    content,
    okTitle,
    cancelTitle,
    okButtonComponent,
    showContactButton = false,
    showIcon = true,
    okButtonType = ButtonTypes.PrimaryFilled,
    isHtmlContent,
    popupStyle,
    buttonContainerStyle,
    hotline = t('hotline'),
    icon = iconErrorLarge,
    showIconClose = false,
    isWebsite = false,
    classIcon = false,
  } = props;

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [visible]);

  if (!visible) return null;

  const modal = (
    <div className={`popupModal`} style={{ zIndex: 2147483647, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div
      className={`relative w-full ${isWebsite ? 'max-w-4xl' : 'max-w-md'} mx-auto flex-col flex items-center`}>
      <div
        className={`relative p-6 bg-white w-full ${isWebsite ? 'max-w-4xl' : 'max-w-md'} m-auto flex-col flex rounded-lg items-center max-h-[690px] overflow-y-scroll md:overflow-hidden`}
        style={popupStyle}
      >
        {showIconClose && (
          <div className={'absolute right-4 top-4 hover:cursor-pointer'} onClick={() => onCancel && onCancel()}>
            <img src={iconClose} alt="close" className="w-6 h-6" />
          </div>
        )}
        {showIcon && (
          <div className={'pt-4 pb-7'}>
            <img src={icon} alt="icon" className={classIcon ? classIcon : "w-20 h-20"} />
          </div>
        )}
        <div>
          <p className="font-semibold leading-8 text-center text-lg md:text-[26px]">{title}</p>
        </div>
        {children ? (
          <div>{children}</div>
        ) : (
          <div className="pt-3 pb-8">
            {!isHtmlContent ? (
              <p className="popupContentText text-center">
                {formatTextWithPhoneNumbers(content || '')}
              </p>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: content }} />
            )}
          </div>
        )}
        <div
          className="flex flex-col space-y-4 w-full"
          style={buttonContainerStyle}
        >
          {!!onCancel && !showIconClose &&(
            <Button
              onClick={onCancel}
              text={cancelTitle ? cancelTitle : t('cancel')}
              extraClassName={'w-full'}
              buttonType={ButtonTypes.ErrorBorderless}
            />
          )}
          {okButtonComponent ? (
            okButtonComponent
          ) : showContactButton ? (
            <a
              href={`tel:${hotline}`}
              onClick={(e) => {
                e.preventDefault();
                handlePhoneCall(hotline);
                // Call onOk callback if exists
                if (onOk) onOk();
              }}
            >
              <Button
                text={t('contact_now')}
                extraClassName={'w-full'}
                buttonType={okButtonType}
              />
            </a>
          ) : (
            !!onOk && (
              <Button
                onClick={onOk}
                text={okTitle ? okTitle : t('ok')}
                extraClassName={'w-full'}
                buttonType={okButtonType}
              />
            )
          )}
        </div>
      </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
};
export default PopupConfirm;
